export default {
      id: "ce_gray-usage",
      viewBox: "0 0 23 17",
      url: __webpack_public_path__ + "sprite.svg#ce_gray",
      toString: function () {
        return this.url;
      }
    }